import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPipelinePlannedPlantationsInputDto, PipelinePlannedPlantationCreateDto, PipelinePlannedPlantationDto, PipelinePlannedPlantationExcelDownloadDto, PipelinePlannedPlantationUpdateDto } from '../dtos/pipeline-planned-plantation/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PipelinePlannedPlantationService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: PipelinePlannedPlantationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationDto>({
      method: 'POST',
      url: '/api/operational/pipelinePlannedPlantations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/pipelinePlannedPlantations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/pipelinePlannedPlantations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationDto>({
      method: 'GET',
      url: `/api/operational/pipelinePlannedPlantations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPipelinePlannedPlantationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PipelinePlannedPlantationDto>>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantations',
      params: { pipelinePlannedPlantationHeaderId: input.pipelinePlannedPlantationHeaderId, pipelinePlannedPlantationHeaderName: input.pipelinePlannedPlantationHeaderName, pipelineStandId: input.pipelineStandId, pipelineStandName: input.pipelineStandName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PipelinePlannedPlantationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/pipelinePlannedPlantations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, pipelinePlannedPlantationHeaderId: input.pipelinePlannedPlantationHeaderId, pipelinePlannedPlantationHeaderName: input.pipelinePlannedPlantationHeaderName, pipelineStandId: input.pipelineStandId, pipelineStandName: input.pipelineStandName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationDto[]>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationDto>({
      method: 'POST',
      url: `/api/operational/pipelinePlannedPlantations/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PipelinePlannedPlantationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationDto>({
      method: 'PUT',
      url: `/api/operational/pipelinePlannedPlantations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}